import { Instance } from 'mobx-state-tree';
import { RouteReOptimizedDtoModelBase } from './RouteReOptimizedDtoModel.base';

/* The TypeScript type of an instance of RouteReOptimizedDtoModel */
export interface RouteReOptimizedDtoModelType extends Instance<typeof RouteReOptimizedDtoModel.Type> {}

/* A graphql query fragment builders for RouteReOptimizedDtoModel */
export { selectFromRouteReOptimizedDto, routeReOptimizedDtoModelPrimitives, RouteReOptimizedDtoModelSelector } from './RouteReOptimizedDtoModel.base';

/**
 * RouteReOptimizedDtoModel
 */
export const RouteReOptimizedDtoModel = RouteReOptimizedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
